import type { App, AppActions, ActionsProvider } from '@nab/x-types';

const actionsProviders: ActionsProvider[] = [];
let shellActions: AppActions;

export const registerActionsProvider = (provider: ActionsProvider): void => {
    actionsProviders.push(provider);
};

export const getActionsProviders = (): ActionsProvider[] => actionsProviders;

/**
 * Creates a set of action functions for a specific app instance
 */
export const createActionsForAppInstance = (appMetaData: App, instanceId: string, defaultActionsProvider: ActionsProvider): AppActions => {
    let actions: AppActions = defaultActionsProvider(appMetaData, instanceId) as AppActions;

    // Add all registered actions providers
    for (const ap of actionsProviders) {
        actions = {
            ...actions,
            ...ap(appMetaData, instanceId)
        };
    }

    return actions;
};

export const setShellActions = (actions: AppActions) => {
    shellActions = actions;
};

export const getShellActions = (): AppActions => {
    if (typeof shellActions !== 'object') {
        throw new Error(`x-runtime has not been initialised. Please initialise it using the initRuntime function`);
    }
    return shellActions;
};

export const resetActionsRegistry = () => {
    shellActions = undefined;
    actionsProviders.splice(0, actionsProviders.length);
};
